const getters = {
  // 获取主题相关
  theme: state => state.theme.theme,
  sideTheme: state => state.theme.sideTheme,
  logoTheme: state => state.theme.logoTheme,
  headerTheme: state => state.theme.headerTheme,

  // 获取用户相关
  name: state => state.user.name,
  phone: state => state.user.phone,
  avatar: state => state.user.avatar,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  level: state => state.user.level,
  // 获取路由相关
  sidebarRouters: state => state.route.sidebarRouters,

  // 获取tabView
  visitedViewList: state => state.tagsView.visitedViewList,
  // 字典
  cowProductType: state => state.dict.cowProductType,
  yesno: state => state.dict.yesno,
  proceeds_return_type: state => state.dict.proceeds_return_type,
  physical_return_type: state => state.dict.physical_return_type,
  reward_integral_type: state => state.dict.reward_integral_type,
  reward_superior_integral_type: state => state.dict.reward_superior_integral_type,
  reward_amount_type: state => state.dict.reward_amount_type,
  reward_superior_amount_type: state => state.dict.reward_superior_amount_type,
  breed_cycle: state => state.dict.breed_cycle,
  cow_variety: state => state.dict.cow_variety,
  product_state: state => state.dict.product_state,
  product_tag: state => state.dict.product_tag,
  cow_sex: state => state.dict.cow_sex,
  health_state: state => state.dict.health_state,
  vaccine_state: state => state.dict.vaccine_state,
  insurance_state: state => state.dict.insurance_state,
  insurance_company: state => state.dict.insurance_company,
  cow_state: state => state.dict.cow_state,
  cow_sell_state: state => state.dict.cow_sell_state,
  order_type: state => state.dict.order_type,
  order_state: state => state.dict.order_state,
  ear_tag_state: state => state.dict.ear_tag_state,
  coupon_type: state => state.dict.coupon_type,
  coupon_usage_scenario: state => state.dict.coupon_usage_scenario,
  coupon_provide_type: state => state.dict.coupon_provide_type,
  coupon_state: state => state.dict.coupon_state,
  monitor_brand: state => state.dict.monitor_brand,
  monitor_state: state => state.dict.monitor_state,
  express_company: state => state.dict.express_company,
  physical_earning_state: state => state.dict.physical_earning_state,
  mem_coupon_state: state => state.dict.mem_coupon_state,
  foster_cow_state: state => state.dict.foster_cow_state,
  mem_real_name_state: state => state.dict.mem_real_name_state,
  cow_portion_state: state => state.dict.cow_portion_state,
  withdrawal_apply_type: state => state.dict.withdrawal_apply_type,
  withdrawal_apply_audit_state: state => state.dict.withdrawal_apply_audit_state,
  withdrawal_apply_transfer_state: state => state.dict.withdrawal_apply_transfer_state,
  balance_type: state => state.dict.balance_type,
  balance_deal_state: state => state.dict.balance_deal_state,
  withdraw_state: state => state.dict.withdraw_state,
  withdraw_type: state => state.dict.withdraw_type,
  income_type: state => state.dict.income_type,
  proceeds_return_state: state => state.dict.proceeds_return_state,
  integral_change_type: state => state.dict.integral_change_type,
  channel_type: state => state.dict.channel_type,
  channel_state: state => state.dict.channel_state,
}
export default getters
